import { useRef } from 'react';
import { Table } from 'react-bootstrap';
import { useReactToPrint } from "react-to-print";

const PrintLoadSheet = ({ title, orders }) => {

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({
        contentRef,
        pageStyle: `
                @media print {

                    @page {
                        size: A4 landscape !important;
                    }

                    .page-break {
                        page-break-after: always;
                    }

                    table {
                        width: 100%;
                    }
                }
                `
    });

    const currentDate = new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });

    const itemsPerPrintPage = 9;

    // 🔥 Split orders into chunks of 8
    const chunkedOrders = [];
    for (let i = 0; i < orders.length; i += itemsPerPrintPage) {
        chunkedOrders.push(orders.slice(i, i + itemsPerPrintPage));
    }

    return (
        <>

            <div>
                <button onClick={reactToPrintFn} className="btn btn-dark">
                    {title}
                </button>

                <div ref={contentRef} className='printContent'>


                    {/* Header */}
                    <div className='row fw-bold'>
                        <div className="col">
                            <h6 className='fw-bold'>
                                Load Sheet Of VPP Parcel Of AR E Cart At Nazimabad HPO
                            </h6>
                        </div>
                        <div className="col-auto">
                            Dated : {currentDate}
                        </div>
                    </div>
                    {chunkedOrders.map((pageOrders, pageIndex) => (
                        <div
                            key={pageIndex}
                            className={pageIndex !== chunkedOrders.length - 1 ? "page-break" : ""}
                        >

                            <Table bordered className=''>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Order ID</th>
                                        <th>VPP Number</th>
                                        <th>Name</th>
                                        <th>Address</th>
                                        <th>Number</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pageOrders.map((o, i) => (
                                        <tr key={o.id}>
                                            <td>{i + 1 + pageIndex * itemsPerPrintPage}</td>
                                            <td>{o.trackingId}</td>
                                            <td>{o.VppNumber}</td>
                                            <td>{o.customerName}</td>
                                            <td>{o.address}</td>
                                            <td>{o.phoneNumber}</td>
                                            <td>
                                                {o?.amount
                                                    ? (Number(o.amount) < 10000
                                                        ? Number(o.amount) - 75
                                                        : Number(o.amount) - 100)
                                                    : 0}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    ))}

                </div>
            </div>
        </>
    )
}

export default PrintLoadSheet;